(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-coupon-allowance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-coupon-allowance')) {
    class ProductCouponAllowance extends HTMLElement {
      constructor() {
        super();
        this.handleCopy = this.handleCopy.bind(this);
      }

      connectedCallback() {
        this.drawer = this.querySelector('.coupon-allowance-drawer');
        this.drawer?.addEventListener('click', this.handleCopy);
      }

      disconnectedCallback() {
        this.drawer?.removeEventListener('click', this.handleCopy);
      }

      async handleCopy(event) {
        const button = event.target.closest('[data-copy-code]');

        if (!button || !event.currentTarget.contains(button)) {
          return;
        }

        try {
          await this.copyText(button.dataset.copyCode, button);
          this.updateButtonState(button, button.dataset.copiedLabel, 'copied');
        } catch (error) {
          this.updateButtonState(button, button.dataset.copyErrorLabel, 'error');
        }
      }

      async copyText(value, button) {
        if (navigator.clipboard && window.isSecureContext) {
          try {
            await navigator.clipboard.writeText(value);
            return;
          } catch (error) {
          }
        }

        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        this.drawer.append(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();
        button.focus({ preventScroll: true });

        if (!copied) {
          throw new Error('Copy failed');
        }
      }

      updateButtonState(button, feedbackLabel, state) {
        const label = button.querySelector('[data-copy-label]');
        const status = button.querySelector('[data-copy-status]');

        if (!label || !status) {
          return;
        }

        window.clearTimeout(button.copyResetTimer);
        button.dataset.copyState = state;
        label.textContent = feedbackLabel;
        status.textContent = feedbackLabel;

        button.copyResetTimer = window.setTimeout(() => {
          delete button.dataset.copyState;
          label.textContent = button.dataset.copyLabel;
          status.textContent = '';
        }, 4000);
      }
    }

    customElements.define('product-coupon-allowance', ProductCouponAllowance);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-coupon-checkbox"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-variant-coupons')) {
    class ProductCouponCheckbox extends HTMLElement {
      constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleCartChange = this.handleCartChange.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
      }

      connectedCallback() {
        this.initializationFrame = window.requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.isInitialized || !this.isConnected) {
          return;
        }

        this.isInitialized = true;
        this.emptyState = this.querySelector('[data-coupon-empty-state]');
        this.emptyStateText = this.querySelector('[data-coupon-empty-state-text]');
        this.configContainer = this.querySelector('[data-coupon-items]');
        this.refreshVariantConfigs();
        this.configRevision = 0;
        this.urlCouponHandled = false;

        const productRerender = this.closest('product-rerender[observe-form]');
        const formId = productRerender?.getAttribute('observe-form');
        this.productForm = formId ? document.forms[formId] || document.getElementById(formId) : null;

        this.addEventListener('change', this.handleChange);
        this.productForm?.addEventListener('variant:change', this.handleVariantChange);
        document.addEventListener('cart:change', this.handleCartChange);

        this.currentVariant = {
          id: this.dataset.currentVariantId,
          sku: this.dataset.currentVariantSku,
          title: this.dataset.currentVariantTitle
        };

        if (this.configContainer) {
          this.variantConfigObserver = new MutationObserver(() => this.scheduleVariantConfigRefresh());
          this.variantConfigObserver.observe(this.configContainer, {
            childList: true,
            subtree: false
          });
        }

        this.activateVariant(this.currentVariant);
      }

      disconnectedCallback() {
        window.cancelAnimationFrame(this.initializationFrame);
        window.cancelAnimationFrame(this.variantRefreshFrame);
        window.clearInterval(this.countdownTimer);
        this.variantConfigObserver?.disconnect();
        this.setProductFormBusy(false);
        this.removeEventListener('change', this.handleChange);
        this.productForm?.removeEventListener('variant:change', this.handleVariantChange);
        document.removeEventListener('cart:change', this.handleCartChange);
        this.isInitialized = false;
      }

      handleVariantChange(event) {
        this.activateVariant(event.detail?.variant || null);
      }

      refreshVariantConfigs() {
        this.variantConfigs = Array.from(this.querySelectorAll('[data-coupon-variant-config]'));
      }

      scheduleVariantConfigRefresh() {
        window.cancelAnimationFrame(this.variantRefreshFrame);
        this.variantRefreshFrame = window.requestAnimationFrame(() => {
          if (!this.isConnected) {
            return;
          }

          this.refreshVariantConfigs();
          this.activateVariant(this.currentVariant);
        });
      }

      activateVariant(variant) {
        this.currentVariant = variant;
        this.configRevision += 1;
        window.clearInterval(this.countdownTimer);
        this.countdownTimer = null;
        this.isExpired = false;

        const config = variant ? this.resolveVariantConfig(variant) : {
          variantId: 'unavailable',
          discountCode: '',
          showCountdown: false,
          countdownEnd: '',
          expiredLabel: 'Expired',
          matched: false,
          element: null
        };

        const isDesignMode = this.dataset.designMode === 'true';
        const hasCoupon = Boolean(config.discountCode);
        const showConfiguredPreview = isDesignMode && config.matched;
        const showActiveItem = hasCoupon || showConfiguredPreview;

        this.variantConfigs.forEach((item) => {
          item.hidden = item !== config.element || !showActiveItem;
        });

        this.activeConfig = config.element;
        this.input = this.activeConfig?.querySelector('[data-coupon-checkbox-input]') || null;
        this.status = this.activeConfig?.querySelector('[data-coupon-checkbox-status]') || null;
        this.countdownTime = this.activeConfig?.querySelector('[data-coupon-countdown]') || null;
        this.countdownPrefix = this.activeConfig?.querySelector('[data-coupon-countdown-prefix]') || null;
        this.countdownWrapper = this.activeConfig?.querySelector('[data-coupon-countdown-wrapper]') || null;

        this.activeVariantId = String(config.variantId || 'default');
        this.dataset.discountCode = config.discountCode;
        this.dataset.countdownEnd = config.countdownEnd;
        this.dataset.expiredLabel = config.expiredLabel;
        this.storageKey = this.buildStorageKey(this.activeVariantId, config.discountCode);

        this.classList.remove('is-applying', 'is-applied', 'is-selected', 'is-error', 'is-expired');
        const showEmptyState = isDesignMode && this.variantConfigs.length === 0;

        this.hidden = !showActiveItem && !showEmptyState;

        if (this.emptyState) {
          this.emptyState.hidden = !showEmptyState;
        }

        if (showEmptyState && this.emptyStateText) {
          this.emptyStateText.textContent = this.getEmptyStateMessage(config);
        }

        if (this.input) {
          this.input.checked = false;
          this.input.disabled = !config.discountCode;
        }

        if (this.status) {
          this.status.textContent = !hasCoupon && showConfiguredPreview ? 'Enter discount code' : '';
        }

        if (this.countdownPrefix) {
          this.countdownPrefix.hidden = false;
        }

        if (this.countdownTime) {
          this.countdownTime.textContent = '';
          this.countdownTime.dateTime = config.countdownEnd;
        }

        if (!hasCoupon) {
          return;
        }

        if ((!config.showCountdown || !this.setupCountdown())) {
          this.restoreState();
        }
      }

      resolveVariantConfig(variant) {
        const matchingConfig = this.variantConfigs.find((config) => (
          config.dataset.matchBy !== 'all' && this.matchesVariant(config, variant)
        )) || this.variantConfigs.find((config) => (
          config.dataset.matchBy === 'all'
        ));
        const matchedCode = matchingConfig?.dataset.discountCode?.trim() || '';

        return {
          variantId: variant.id || 'default',
          discountCode: matchingConfig ? matchedCode : '',
          showCountdown: matchingConfig?.dataset.showCountdown === 'true',
          countdownEnd: matchingConfig?.dataset.countdownEnd?.trim() || '',
          expiredLabel: matchingConfig?.dataset.expiredLabel?.trim() || 'Expired',
          matched: Boolean(matchingConfig),
          element: matchingConfig || null
        };
      }

      getEmptyStateMessage(config) {
        if (this.variantConfigs.length === 0) {
          return 'Add a Variant coupon child block and enter its discount code.';
        }

        if (!config.matched) {
          return 'No Variant coupon matches the currently selected variant.';
        }

        return 'Enter a discount code in the matched Variant coupon block.';
      }

      matchesVariant(config, variant) {
        if (config.dataset.matchBy === 'all') {
          return true;
        }

        const matchValue = String(config.dataset.matchValue || '').trim();

        if (!matchValue) {
          return false;
        }

        if (config.dataset.matchBy === 'variant_id') {
          return String(variant.id || '').trim() === matchValue;
        }

        const variantValue = config.dataset.matchBy === 'title' ? variant.title : variant.sku;
        return String(variantValue || '').trim().toLocaleLowerCase() === matchValue.toLocaleLowerCase();
      }

      buildStorageKey(variantId, discountCode) {
        return `product-coupon:${this.dataset.productId}:${this.dataset.blockId}:${variantId}:${discountCode}`;
      }

      getOperationContext() {
        return {
          revision: this.configRevision,
          discountCode: this.dataset.discountCode || '',
          storageKey: this.storageKey,
          variantId: this.activeVariantId
        };
      }

      isCurrentContext(context) {
        return context.revision === this.configRevision
          && context.discountCode === (this.dataset.discountCode || '')
          && context.variantId === this.activeVariantId;
      }

      restoreState() {
        if (this.hasDismissedState()) {
          this.clearStoredStatesForCode(this.dataset.discountCode);
          this.removeDiscountCode(this.getOperationContext()).catch(() => {
          });
          return;
        }

        let hasStoredState = this.hasStoredState();

        const url = new URL(window.location.href);
        if (!this.urlCouponHandled && url.searchParams.get('coupon_applied') === this.dataset.blockId) {
          this.urlCouponHandled = true;
          url.searchParams.delete('coupon_applied');
          window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
          this.persistAppliedState();
          hasStoredState = true;
        }

        if (hasStoredState) {
          this.setSelectedState();
          this.syncSelectedDiscount();
        }
      }

      hasStoredState(storageKey = this.storageKey) {
        try {
          return window.sessionStorage.getItem(storageKey) === 'applied';
        } catch (error) {
          return false;
        }
      }

      buildDismissedKey(discountCode = this.dataset.discountCode) {
        return `product-coupon-dismissed:${this.dataset.productId}:${this.dataset.blockId}:${discountCode.toLowerCase()}`;
      }

      hasDismissedState(discountCode = this.dataset.discountCode) {
        if (!discountCode) {
          return false;
        }

        try {
          return window.sessionStorage.getItem(this.buildDismissedKey(discountCode)) === 'dismissed';
        } catch (error) {
          return false;
        }
      }

      persistDismissedState(discountCode = this.dataset.discountCode) {
        if (!discountCode) {
          return;
        }

        try {
          window.sessionStorage.setItem(this.buildDismissedKey(discountCode), 'dismissed');
        } catch (error) {
        }
      }

      clearDismissedState(discountCode = this.dataset.discountCode) {
        if (!discountCode) {
          return;
        }

        try {
          window.sessionStorage.removeItem(this.buildDismissedKey(discountCode));
        } catch (error) {
        }
      }

      clearStoredStatesForCode(discountCode = this.dataset.discountCode) {
        if (!discountCode) {
          return;
        }

        const storagePrefix = `product-coupon:${this.dataset.productId}:${this.dataset.blockId}:`;
        const codeSuffix = `:${discountCode}`.toLowerCase();

        try {
          const matchingKeys = [];

          for (let index = 0; index < window.sessionStorage.length; index += 1) {
            const key = window.sessionStorage.key(index);

            if (key?.startsWith(storagePrefix) && key.toLowerCase().endsWith(codeSuffix)) {
              matchingKeys.push(key);
            }
          }

          matchingKeys.forEach((key) => window.sessionStorage.removeItem(key));
        } catch (error) {
        }
      }

      setupCountdown() {
        if (!this.countdownTime || !this.dataset.countdownEnd) {
          return false;
        }

        this.expiryTimestamp = Date.parse(this.dataset.countdownEnd);

        if (Number.isNaN(this.expiryTimestamp)) {
          this.countdownWrapper.hidden = true;
          return false;
        }

        if (!this.updateCountdown()) {
          return true;
        }

        this.countdownTimer = window.setInterval(() => this.updateCountdown(), 1000);
        return false;
      }

      updateCountdown() {
        const remainingSeconds = Math.max(0, Math.floor((this.expiryTimestamp - Date.now()) / 1000));

        if (remainingSeconds <= 0) {
          this.expireCoupon();
          return false;
        }

        const days = Math.floor(remainingSeconds / 86400);
        const hours = Math.floor((remainingSeconds % 86400) / 3600);
        const minutes = Math.floor((remainingSeconds % 3600) / 60);
        const seconds = remainingSeconds % 60;
        const clock = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');

        this.countdownTime.textContent = days > 0 ? `${days}d ${clock}` : clock;
        return true;
      }

      expireCoupon() {
        const context = this.getOperationContext();
        const shouldRemoveDiscount = this.input?.checked || this.hasStoredState(context.storageKey);

        window.clearInterval(this.countdownTimer);
        this.clearAppliedState(context.storageKey);
        this.setExpiredState();

        if (shouldRemoveDiscount) {
          this.removeExpiredDiscount(context).catch(() => {
          });
        }
      }

      async removeExpiredDiscount(context) {
        await this.removeDiscountCode(context);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }

      async removeDiscountCode(context, suppliedCart = null) {
        const cart = suppliedCart || await this.fetchCart();
        const currentCode = context.discountCode.toLowerCase();
        const remainingCodes = (cart.discount_codes || [])
          .filter((discount) => discount.code.toLowerCase() !== currentCode)
          .map((discount) => discount.code);

        if (remainingCodes.length === (cart.discount_codes || []).length) {
          return cart;
        }

        return this.submitDiscountCodes(remainingCodes);
      }

      async handleChange(event) {
        if (event.target !== this.input || !this.dataset.discountCode || this.isExpired) {
          return;
        }

        const context = this.getOperationContext();
        const shouldApply = this.input.checked;

        if (shouldApply) {
          this.clearDismissedState(context.discountCode);
        } else {
          this.clearStoredStatesForCode(context.discountCode);
          this.persistDismissedState(context.discountCode);
        }

        this.classList.remove('is-error');
        this.classList.add('is-applying');
        this.input.disabled = true;
        this.status.textContent = shouldApply ? this.dataset.applyingLabel : this.dataset.removingLabel;
        this.setProductFormBusy(true);

        try {
          await this.updateDiscount(shouldApply, true, context);
        } catch (error) {
          if (this.isCurrentContext(context)) {
            this.setErrorState(shouldApply, context);
          }
        } finally {
          this.setProductFormBusy(false);
        }
      }

      async handleCartChange(event) {
        if (this.isExpired || this.classList.contains('is-applying')) {
          return;
        }

        const cart = event.detail?.cart;
        const context = this.getOperationContext();
        const discount = this.findDiscount(cart, context.discountCode);

        if (!this.input?.checked) {
          if (discount && this.hasDismissedState(context.discountCode)) {
            try {
              await this.removeDiscountCode(context, cart);
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            } catch (error) {
              if (this.isCurrentContext(context)) {
                this.setErrorState(false, context);
              }
            }
          }

          return;
        }

        if (discount) {
          if (discount.applicable) {
            this.setAppliedState();
          } else if (!this.isVariantInCart(cart, context.variantId)) {
            this.setSelectedState();
          } else {
            await this.syncSelectedDiscount();
          }

          return;
        }

        await this.syncSelectedDiscount();
      }

      async syncSelectedDiscount() {
        if (this.isExpired || !this.input?.checked || this.classList.contains('is-applying')) {
          return;
        }

        const context = this.getOperationContext();

        try {
          await this.updateDiscount(true, false, context);
        } catch (error) {
          if (this.isCurrentContext(context)) {
            this.setErrorState(true, context);
          }
        }
      }

      async updateDiscount(shouldApply, showLoading = true, context = this.getOperationContext()) {
        if (!context.discountCode) {
          return;
        }

        if (showLoading && this.isCurrentContext(context)) {
          this.classList.remove('is-error');
          this.classList.add('is-applying');
          this.input.disabled = true;
        }

        const cart = await this.fetchCart();
        const currentCode = context.discountCode.toLowerCase();
        const discountCodes = (cart.discount_codes || [])
          .filter((discount) => discount.code.toLowerCase() !== currentCode)
          .map((discount) => discount.code);

        if (shouldApply) {
          discountCodes.push(context.discountCode);
        }

        const updatedCart = await this.submitDiscountCodes(discountCodes);

        if (shouldApply) {
          if (this.isCurrentContext(context) && this.isExpired) {
            this.setExpiredState();
            return;
          }

          const discount = this.findDiscount(updatedCart, context.discountCode);

          if (!discount) {
            throw new Error('Discount code was not returned by the cart');
          }

          if (!discount.applicable && this.isVariantInCart(updatedCart, context.variantId)) {
            await this.submitDiscountCodes(
              discountCodes.filter((code) => code.toLowerCase() !== currentCode)
            );
            throw new Error('Discount code is not applicable to the current cart');
          }

          this.persistAppliedState(context.storageKey, context.discountCode);

          if (this.isCurrentContext(context)) {
            if (discount.applicable) {
              this.setAppliedState();
            } else {
              this.setSelectedState();
            }
          }
        } else {
          if (this.findDiscount(updatedCart, context.discountCode)) {
            throw new Error('Discount code was not removed from the cart');
          }

          this.clearStoredStatesForCode(context.discountCode);
          this.persistDismissedState(context.discountCode);

          if (this.isCurrentContext(context)) {
            this.setRemovedState();
          }
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }

      async submitDiscountCodes(discountCodes) {
        const cartUpdateUrl = `${window.Shopify?.routes?.root || '/'}cart/update.js`;
        const response = await window.fetch(cartUpdateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            discount: discountCodes.join(',')
          })
        });

        if (!response.ok) {
          throw new Error(`Discount request failed with status ${response.status}`);
        }

        return response.json();
      }

      async fetchCart() {
        const cartUrl = `${window.Shopify?.routes?.root || '/'}cart.js`;
        const response = await window.fetch(cartUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Cart request failed with status ${response.status}`);
        }

        return response.json();
      }

      findDiscount(cart, discountCode = this.dataset.discountCode) {
        if (!discountCode) {
          return null;
        }

        const currentCode = discountCode.toLowerCase();
        return cart?.discount_codes?.find((discount) => discount.code.toLowerCase() === currentCode);
      }

      isVariantInCart(cart, variantId = this.activeVariantId) {
        return Boolean(cart?.items?.some((item) => String(item.variant_id) === String(variantId)));
      }

      persistAppliedState(storageKey = this.storageKey, discountCode = this.dataset.discountCode) {
        try {
          window.sessionStorage.setItem(storageKey, 'applied');
          this.clearDismissedState(discountCode);
        } catch (error) {
        }
      }

      clearAppliedState(storageKey = this.storageKey) {
        try {
          window.sessionStorage.removeItem(storageKey);
        } catch (error) {
        }
      }

      setProductFormBusy(isBusy) {
        if (!this.productForm) {
          return;
        }

        if (isBusy) {
          this.lockedSubmitButtons = Array.from(
            this.productForm.querySelectorAll('[type="submit"], .shopify-payment-button__button')
          ).map((button) => ({ button, wasDisabled: button.disabled }));
          this.lockedSubmitButtons.forEach(({ button }) => {
            button.disabled = true;
          });
          return;
        }

        (this.lockedSubmitButtons || []).forEach(({ button, wasDisabled }) => {
          button.disabled = wasDisabled;
        });
        this.lockedSubmitButtons = [];
      }

      setAppliedState() {
        this.classList.remove('is-applying', 'is-error', 'is-selected');
        this.classList.add('is-applied');
        this.input.checked = true;
        this.input.disabled = false;
        this.status.textContent = this.dataset.appliedLabel;
      }

      setSelectedState() {
        this.classList.remove('is-applying', 'is-applied', 'is-error');
        this.classList.add('is-selected');
        this.input.checked = true;
        this.input.disabled = false;
        this.status.textContent = this.dataset.selectedLabel;
      }

      setRemovedState() {
        this.classList.remove('is-applying', 'is-applied', 'is-selected', 'is-error');
        this.input.checked = false;
        this.input.disabled = !this.dataset.discountCode;
        this.status.textContent = '';
      }

      setExpiredState() {
        this.isExpired = true;
        this.classList.remove('is-applying', 'is-applied', 'is-selected', 'is-error');
        this.classList.add('is-expired');
        this.input.checked = false;
        this.input.disabled = true;
        this.status.textContent = '';

        if (this.countdownPrefix) {
          this.countdownPrefix.hidden = true;
        }

        if (this.countdownTime) {
          this.countdownTime.textContent = this.dataset.expiredLabel;
        }
      }

      setErrorState(wasApplying, context = this.getOperationContext()) {
        if (this.isExpired) {
          this.setExpiredState();
          return;
        }

        this.classList.remove('is-applying');
        this.classList.add('is-error');
        this.input.checked = !wasApplying;
        this.input.disabled = false;
        this.status.textContent = this.dataset.errorLabel;

        if (wasApplying) {
          this.classList.remove('is-applied', 'is-selected');
          this.clearAppliedState(context.storageKey);
        } else {
          this.clearDismissedState(context.discountCode);
          this.persistAppliedState(context.storageKey, context.discountCode);
        }
      }
    }

    customElements.define('product-variant-coupons', ProductCouponCheckbox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-service-highlights"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-service-highlights')) {
    class ProductServiceHighlights extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-service-highlights-track]');
        this.previousButton = this.querySelector('[data-service-highlights-previous]');
        this.nextButton = this.querySelector('[data-service-highlights-next]');
        this.originalItems = [...this.track.querySelectorAll(':scope > .product-service-highlight-item')];
        this.carouselEnabled = this.dataset.style === 'carousel' && this.originalItems.length > 3;
        this.abortController = new AbortController();
        this.autoplayTimer = null;
        this.normalizeTimer = null;
        this.pointerInitiatedFocus = false;
        this.focusIsWithin = false;
        this.isHovered = false;
        const signal = this.abortController.signal;

        this.classList.toggle('is-carousel-active', this.carouselEnabled);
        this.updateControls();

        if (!this.carouselEnabled) {
          return;
        }

        this.setupInfiniteLoop();
        this.previousButton?.addEventListener('click', () => this.scrollByItem(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.scrollByItem(1), { signal });
        this.track.addEventListener('scroll', () => this.scheduleLoopNormalization(), { signal, passive: true });
        this.track.addEventListener('pointerdown', () => this.stopAutoplay(), { signal, passive: true });
        this.track.addEventListener('pointerup', () => this.scheduleLoopNormalization(), { signal, passive: true });
        this.track.addEventListener('pointercancel', () => this.scheduleLoopNormalization(), { signal, passive: true });
        this.addEventListener('mouseenter', () => {
          this.isHovered = true;
          this.stopAutoplay();
        }, { signal });
        this.addEventListener('mouseleave', () => {
          this.isHovered = false;
          this.startAutoplay();
        }, { signal });
        this.addEventListener('pointerdown', () => {
          this.pointerInitiatedFocus = true;
        }, { signal, capture: true, passive: true });
        this.addEventListener('keydown', () => {
          this.pointerInitiatedFocus = false;
        }, { signal, capture: true });
        this.addEventListener('focusin', () => {
          if (this.pointerInitiatedFocus) {
            this.focusIsWithin = false;
            return;
          }
          this.focusIsWithin = true;
          this.stopAutoplay();
        }, { signal });
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) {
              this.focusIsWithin = false;
              this.startAutoplay();
            }
          });
        }, { signal });
        window.addEventListener('resize', () => this.handleResize(), { signal, passive: true });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        }, { signal });

        requestAnimationFrame(() => {
          this.measureLoop();
          this.jumpTo(this.loopStart);
          this.startAutoplay();
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.stopAutoplay();
        window.clearTimeout(this.normalizeTimer);
      }

      updateControls() {
        const showControls = this.carouselEnabled && this.dataset.showControls === 'true';
        this.classList.toggle('has-carousel-controls', showControls);
        if (this.previousButton) {
          this.previousButton.hidden = !showControls;
        }
        if (this.nextButton) {
          this.nextButton.hidden = !showControls;
        }
      }

      setupInfiniteLoop() {
        const before = this.originalItems.map((item) => this.createLoopClone(item));
        const after = this.originalItems.map((item) => this.createLoopClone(item));
        this.track.prepend(...before);
        this.track.append(...after);
      }

      createLoopClone(item) {
        const clone = item.cloneNode(true);
        clone.dataset.carouselClone = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('[data-shopify-editor-block]')
          .forEach((element) => element.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('a, button').forEach((element) => element.setAttribute('tabindex', '-1'));
        return clone;
      }

      measureLoop() {
        const item = this.originalItems[0];
        if (!item) {
          this.cardStep = 0;
          this.cycleWidth = 0;
          this.loopStart = 0;
          return;
        }

        const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        this.cardStep = item.offsetWidth + gap;
        this.cycleWidth = this.originalItems.length * this.cardStep;
        this.loopStart = this.cycleWidth;
      }

      scrollByItem(direction) {
        if (!this.cardStep) {
          return;
        }

        this.stopAutoplay();
        this.normalizeLoop();
        this.track.scrollBy({
          left: direction * this.cardStep,
          behavior: 'smooth'
        });
      }

      scheduleLoopNormalization() {
        window.clearTimeout(this.normalizeTimer);
        this.normalizeTimer = window.setTimeout(() => {
          this.normalizeLoop();
          this.startAutoplay();
        }, 160);
      }

      normalizeLoop() {
        if (!this.cycleWidth || !this.cardStep) {
          return;
        }

        const lowerBoundary = this.loopStart - this.cardStep / 2;
        const upperBoundary = this.loopStart + this.cycleWidth - this.cardStep / 2;
        if (this.track.scrollLeft < lowerBoundary) {
          this.jumpTo(this.track.scrollLeft + this.cycleWidth);
        } else if (this.track.scrollLeft >= upperBoundary) {
          this.jumpTo(this.track.scrollLeft - this.cycleWidth);
        }
      }

      jumpTo(left) {
        const previousScrollBehavior = this.track.style.scrollBehavior;
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = left;
        requestAnimationFrame(() => {
          this.track.style.scrollBehavior = previousScrollBehavior;
        });
      }

      handleResize() {
        const logicalIndex = this.cardStep
          ? Math.round((this.track.scrollLeft - this.loopStart) / this.cardStep)
          : 0;
        this.measureLoop();
        this.jumpTo(this.loopStart + logicalIndex * this.cardStep);
        this.startAutoplay();
      }

      startAutoplay() {
        this.stopAutoplay();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (
          !this.carouselEnabled
          || reducedMotion
          || document.hidden
          || this.isHovered
          || this.focusIsWithin
        ) {
          return;
        }

        const interval = Math.max(2000, Number(this.dataset.autoplayInterval) || 4000);
        this.autoplayTimer = window.setTimeout(() => this.scrollByItem(1), interval);
      }

      stopAutoplay() {
        window.clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    customElements.define('product-service-highlights', ProductServiceHighlights);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-video-stories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-video-stories')) {
    class ProductVideoStories extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-video-stories-track]');
        this.previousButton = this.querySelector('[data-video-stories-previous]');
        this.nextButton = this.querySelector('[data-video-stories-next]');
        this.dialog = this.querySelector('[data-video-stories-dialog]');
        this.player = this.querySelector('[data-video-stories-player]');
        this.closeButton = this.querySelector('[data-video-stories-close]');
        this.quickOrderForm = this.querySelector('.product-video-stories__quick-order-form');
        this.abortController = new AbortController();
        this.autoplayTimer = null;
        this.autoplayFallbackTimer = null;
        this.normalizeTimer = null;
        this.inlinePlayer = null;
        this.previewGeneration = 0;
        this.focusIsWithin = false;
        this.pointerInitiatedFocus = false;
        this.autoplayFocusOverride = false;
        const signal = this.abortController.signal;

        this.setupInfiniteLoop();

        this.previousButton?.addEventListener('click', () => this.scrollByCard(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.scrollByCard(1), { signal });
        this.track?.addEventListener('scroll', () => this.scheduleLoopNormalization(), { signal, passive: true });
        this.track?.addEventListener('pointerdown', () => this.stopAutoplay(), { signal, passive: true });
        this.track?.addEventListener('pointerup', () => this.scheduleLoopNormalization(), { signal, passive: true });
        this.track?.addEventListener('pointercancel', () => this.scheduleLoopNormalization(), { signal, passive: true });
        window.addEventListener('resize', () => this.handleResize(), { signal, passive: true });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        }, { signal });
        this.addEventListener('pointerdown', () => {
          this.autoplayFocusOverride = false;
          this.pointerInitiatedFocus = true;
        }, { signal, capture: true, passive: true });
        this.addEventListener('keydown', () => {
          this.autoplayFocusOverride = false;
          this.pointerInitiatedFocus = false;
          this.focusIsWithin = true;
          this.stopAutoplay();
        }, { signal, capture: true });
        this.addEventListener('focusin', () => {
          if (this.pointerInitiatedFocus || this.autoplayFocusOverride) {
            this.focusIsWithin = false;
            return;
          }
          this.focusIsWithin = true;
          this.stopAutoplay();
        }, { signal });
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) {
              this.focusIsWithin = false;
              this.startAutoplay();
            }
          });
        }, { signal });
        this.closeButton?.addEventListener('click', () => this.dialog?.close(), { signal });
        this.dialog?.addEventListener('close', () => {
          this.clearPlayer();
          this.autoplayFocusOverride = true;
          this.focusIsWithin = false;
          requestAnimationFrame(() => this.startAutoplay());
        }, { signal });
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) {
            this.dialog.close();
          }
        }, { signal });
        this.quickOrderForm?.addEventListener('variant:add', () => this.dialog?.close(), { signal });

        this.querySelectorAll('[data-video-story-play]').forEach((button) => {
          button.addEventListener('click', () => this.openVideo(button), { signal });
        });

        requestAnimationFrame(() => {
          this.measureLoop();
          this.jumpTo(this.loopStart);
          this.updateControls();
          this.updateActiveCard();
          this.startAutoplay();
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.stopAutoplay();
        window.clearTimeout(this.normalizeTimer);
        this.clearPlayer();
      }

      setupInfiniteLoop() {
        if (!this.track) {
          return;
        }

        this.originalCards = [...this.track.querySelectorAll(':scope > [data-video-story-card]')];
        this.classList.toggle('is-empty', this.originalCards.length === 0);
        this.classList.toggle('is-single', this.originalCards.length === 1);
        this.loopEnabled = this.originalCards.length > 1;
        if (!this.loopEnabled) {
          return;
        }

        const before = this.originalCards.map((card) => this.createLoopClone(card));
        const after = this.originalCards.map((card) => this.createLoopClone(card));
        this.track.prepend(...before);
        this.track.append(...after);
      }

      createLoopClone(card) {
        const clone = card.cloneNode(true);
        clone.dataset.carouselClone = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('[data-shopify-editor-block]')
          .forEach((element) => element.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('a, button').forEach((element) => element.setAttribute('tabindex', '-1'));
        return clone;
      }

      measureLoop() {
        const card = this.originalCards?.[0];
        if (!card || !this.track) {
          this.cardStep = 0;
          this.cycleWidth = 0;
          this.loopStart = 0;
          return;
        }

        const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        this.cardStep = card.offsetWidth + gap;
        this.cycleWidth = this.originalCards.length * this.cardStep;
        const centerOffset = Math.max(0, (this.track.clientWidth - card.offsetWidth) / 2);
        this.loopStart = this.loopEnabled ? this.cycleWidth - centerOffset : 0;
      }

      scrollByCard(direction) {
        if (!this.track || !this.cardStep) {
          return;
        }

        this.stopAutoplay();
        this.normalizeLoop();
        this.track.scrollBy({
          left: direction * this.cardStep,
          behavior: 'smooth'
        });
      }

      scheduleLoopNormalization() {
        if (!this.track) {
          return;
        }

        window.clearTimeout(this.normalizeTimer);
        this.normalizeTimer = window.setTimeout(() => {
          this.normalizeLoop();
          this.updateActiveCard();
          this.startAutoplay();
        }, 120);
      }

      normalizeLoop() {
        if (!this.loopEnabled || !this.cycleWidth || !this.track) {
          return;
        }

        const lowerBoundary = this.loopStart - this.cardStep / 2;
        const upperBoundary = this.loopStart + this.cycleWidth - this.cardStep / 2;
        if (this.track.scrollLeft < lowerBoundary) {
          this.jumpTo(this.track.scrollLeft + this.cycleWidth);
        } else if (this.track.scrollLeft >= upperBoundary) {
          this.jumpTo(this.track.scrollLeft - this.cycleWidth);
        }
      }

      jumpTo(left) {
        if (!this.track || !Number.isFinite(left)) {
          return;
        }

        const previousScrollBehavior = this.track.style.scrollBehavior;
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = left;
        requestAnimationFrame(() => {
          this.track.style.scrollBehavior = previousScrollBehavior;
        });
      }

      handleResize() {
        const logicalIndex = this.cardStep
          ? Math.round((this.track.scrollLeft - this.loopStart) / this.cardStep)
          : 0;
        this.measureLoop();
        this.jumpTo(this.loopStart + logicalIndex * this.cardStep);
        this.updateControls();
        this.updateActiveCard();
        this.startAutoplay();
      }

      updateControls() {
        if (!this.track) {
          return;
        }

        const shouldDisable = (this.originalCards?.length || 0) <= 1;
        if (this.previousButton) {
          this.previousButton.disabled = shouldDisable;
        }
        if (this.nextButton) {
          this.nextButton.disabled = shouldDisable;
        }
      }

      startAutoplay() {
        this.stopAutoplay();
        const activeCard = this.updateActiveCard();
        const autoplayEnabled = this.dataset.autoplay === 'true';
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const shouldPause = document.hidden
          || (this.focusIsWithin && !this.autoplayFocusOverride)
          || this.dialog?.open;
        if (!autoplayEnabled || reducedMotion || shouldPause || !this.loopEnabled || !activeCard) {
          return;
        }

        const interval = Math.max(3000, Number(this.dataset.autoplayInterval) || 3000);
        this.playInlinePreview(activeCard, interval);
      }

      stopAutoplay() {
        window.clearTimeout(this.autoplayTimer);
        window.clearTimeout(this.autoplayFallbackTimer);
        this.autoplayTimer = null;
        this.autoplayFallbackTimer = null;
        this.stopInlinePreview();
      }

      updateActiveCard() {
        if (!this.track) {
          return null;
        }

        const cards = [...this.track.querySelectorAll(':scope > .product-video-story-card')];
        if (cards.length === 0) {
          return null;
        }

        const trackRect = this.track.getBoundingClientRect();
        const trackCenter = trackRect.left + trackRect.width / 2;
        let activeCard = cards[0];
        let closestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card) => {
          const rect = card.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - trackCenter);
          card.classList.remove('is-active');
          if (distance < closestDistance) {
            closestDistance = distance;
            activeCard = card;
          }
        });

        activeCard.classList.add('is-active');
        return activeCard;
      }

      async playInlinePreview(card, interval) {
        const videoId = card?.dataset.videoId;
        const container = card?.querySelector('[data-video-inline-player]');
        if (!videoId || !container) {
          return;
        }

        const generation = ++this.previewGeneration;
        this.autoplayFallbackTimer = window.setTimeout(
          () => this.schedulePreviewFallback(generation, interval),
          8000
        );
        try {
          await this.waitForWindowLoad();
          const YouTube = await this.loadYouTubePlayerApi();
          if (generation !== this.previewGeneration || !card.isConnected) {
            return;
          }

          const mount = document.createElement('div');
          container.replaceChildren(mount);
          container.hidden = false;
          container.setAttribute('aria-hidden', 'false');

          this.inlinePlayer = new YouTube.Player(mount, {
            videoId,
            playerVars: {
              autoplay: 0,
              controls: 1,
              playsinline: 1,
              rel: 0
            },
            events: {
              onReady: (event) => {
                if (generation !== this.previewGeneration) {
                  return;
                }
                event.target.mute();
                event.target.playVideo();
              },
              onStateChange: (event) => {
                if (
                  generation === this.previewGeneration
                  && event.data === YouTube.PlayerState.PLAYING
                  && !this.autoplayTimer
                ) {
                  window.clearTimeout(this.autoplayFallbackTimer);
                  this.autoplayTimer = window.setTimeout(() => {
                    if (generation === this.previewGeneration) {
                      this.scrollByCard(1);
                    }
                  }, interval);
                }
              },
              onAutoplayBlocked: () => this.schedulePreviewFallback(generation, interval)
            }
          });

        } catch (error) {
          this.schedulePreviewFallback(generation, interval);
        }
      }

      schedulePreviewFallback(generation, interval) {
        if (generation !== this.previewGeneration || this.autoplayTimer) {
          return;
        }

        window.clearTimeout(this.autoplayFallbackTimer);
        this.autoplayTimer = window.setTimeout(() => {
          if (generation === this.previewGeneration) {
            this.scrollByCard(1);
          }
        }, interval);
      }

      stopInlinePreview() {
        this.previewGeneration += 1;
        if (this.inlinePlayer?.destroy) {
          try {
            this.inlinePlayer.destroy();
          } catch (error) {
            // The player may already be detached while the carousel is moving.
          }
        }
        this.inlinePlayer = null;
        this.querySelectorAll('[data-video-inline-player]').forEach((container) => {
          container.replaceChildren();
          container.hidden = true;
          container.setAttribute('aria-hidden', 'true');
        });
      }

      waitForWindowLoad() {
        if (document.readyState === 'complete') {
          return Promise.resolve();
        }

        return new Promise((resolve) => window.addEventListener('load', resolve, { once: true }));
      }

      loadYouTubePlayerApi() {
        if (window.YT?.Player) {
          return Promise.resolve(window.YT);
        }

        if (!window.productVideoStoriesYouTubeApiPromise) {
          window.productVideoStoriesYouTubeApiPromise = new Promise((resolve, reject) => {
            const previousReadyHandler = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = () => {
              if (typeof previousReadyHandler === 'function') {
                previousReadyHandler();
              }
              resolve(window.YT);
            };

            const existingScript = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
            if (!existingScript) {
              const script = document.createElement('script');
              script.src = 'https://www.youtube.com/iframe_api';
              script.async = true;
              script.addEventListener('error', () => {
                window.productVideoStoriesYouTubeApiPromise = null;
                reject(new Error('Unable to load YouTube IFrame API'));
              }, { once: true });
              document.head.append(script);
            }
          });
        }

        return window.productVideoStoriesYouTubeApiPromise;
      }

      openVideo(button) {
        const videoId = button.dataset.videoId;
        if (!this.dialog || !this.player || !videoId) {
          return;
        }

        this.syncQuickOrder();
        this.stopAutoplay();
        const iframe = document.createElement('iframe');
        const encodedId = encodeURIComponent(videoId);
        iframe.src = `https://www.youtube.com/embed/${encodedId}?autoplay=1&rel=0`;
        iframe.title = button.getAttribute('aria-label') || 'Video';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;

        this.player.replaceChildren(iframe);
        this.dialog.showModal();
      }

      syncQuickOrder() {
        const mainForm = document.forms[this.dataset.productFormId];
        const quickForm = this.quickOrderForm;
        if (!mainForm || !quickForm) {
          return;
        }

        const mainVariantInput = mainForm.elements.namedItem('id');
        const quickVariantInput = quickForm.querySelector('[data-video-quick-order-variant]');
        if (mainVariantInput?.value && quickVariantInput) {
          quickVariantInput.value = mainVariantInput.value;
        }

        const mainQuantityInput = mainForm.elements.namedItem('quantity');
        const quickQuantityInput = quickForm.querySelector('[data-video-quick-order-quantity]');
        if (mainQuantityInput && quickQuantityInput) {
          ['min', 'max', 'step'].forEach((attribute) => {
            if (mainQuantityInput.hasAttribute(attribute)) {
              quickQuantityInput.setAttribute(attribute, mainQuantityInput.getAttribute(attribute));
            } else {
              quickQuantityInput.removeAttribute(attribute);
            }
          });
          quickQuantityInput.value = mainQuantityInput.value || quickQuantityInput.min || '1';
        }

        const mainSubmitButton = [...mainForm.elements]
          .find((element) => element.type === 'submit' && !element.classList.contains('shopify-payment-button__button'));
        const quickSubmitButton = quickForm.querySelector('[type="submit"]');
        if (mainSubmitButton && quickSubmitButton) {
          quickSubmitButton.disabled = mainSubmitButton.disabled;
          const buttonLabel = mainSubmitButton.textContent.trim();
          if (buttonLabel) {
            quickSubmitButton.textContent = buttonLabel;
          }
        }

        const productContainer = this.closest('product-rerender');
        const sourcePrice = productContainer?.querySelector('.product-info__price price-list');
        const targetPrice = this.querySelector('[data-video-quick-order-price]');
        if (sourcePrice && targetPrice) {
          targetPrice.replaceChildren(sourcePrice.cloneNode(true));
        }
      }

      clearPlayer() {
        this.player?.replaceChildren();
      }
    }

    customElements.define('product-video-stories', ProductVideoStories);
  }
  } catch(e) { console.error(e); }
})();

})();
